/* Digital Product — shim per i cloni.
   Il markup arriva dal DOM gia' renderizzato del sito originale: qui si
   ripristinano solo le interazioni che erano gestite dal JS del tema. */
(function () {
  var d = document;
  d.documentElement.classList.add('js');
  d.documentElement.classList.remove('no-js');

  /* --- 0. video: il tema originale li avviava via JS --- */
  d.querySelectorAll('video').forEach(function (v) {
    v.muted = true;
    v.playsInline = true;
    if (v.hasAttribute('loop') || v.autoplay) {
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
  });

  /* --- 1. galleria Dawn/Horizon: click su thumbnail -> slide corrispondente --- */
  function dpScrollToSlide(slide) {
    var scroller = slide.closest('.product__media-list, .slider, ul, slideshow-slides');
    if (scroller && scroller.scrollWidth > scroller.clientWidth + 8) {
      var first = scroller.firstElementChild || slide;
      dpSetScroll(scroller, slide.offsetLeft - first.offsetLeft);
    } else if (scroller && scroller.scrollHeight > scroller.clientHeight + 8) {
      var first2 = scroller.firstElementChild || slide;
      scroller.scrollTop = slide.offsetTop - first2.offsetTop;
    } else {
      slide.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
    }
  }

  d.querySelectorAll('.thumbnail-list__item, .thumbnail-list li, [class*="thumbnail-list"] li').forEach(function (li) {
    li.addEventListener('click', function (e) {
      var trigger = e.target.closest('a, button') || li.querySelector('a, button');
      if (!trigger) return;
      var id = trigger.getAttribute('data-target') ||
               (trigger.getAttribute('href') || '').replace('#', '') ||
               trigger.getAttribute('data-media-id');
      var slide = null;
      if (id) slide = d.getElementById(id) || d.querySelector('[data-media-id="' + id + '"]');
      if (!slide) {
        /* nessun id: usa la posizione della miniatura nella lista */
        var list = li.parentElement,
            idx = Array.prototype.indexOf.call(list.children, li),
            slides = d.querySelectorAll('.product__media-list > li');
        slide = slides[idx];
      }
      if (!slide) return;
      e.preventDefault();
      /* alcuni temi mostrano una sola slide per volta con la classe is-active */
      var sibs = slide.parentElement ? slide.parentElement.children : [];
      Array.prototype.forEach.call(sibs, function (x) { x.classList.remove('is-active'); });
      slide.classList.add('is-active');
      slide.classList.remove('scroll-trigger--offscreen');
      dpScrollToSlide(slide);
      var siblings = li.parentElement ? li.parentElement.children : [];
      Array.prototype.forEach.call(siblings, function (x) {
        x.classList.remove('is-active', 'thumbnail-list__item--active');
        var b = x.querySelector('[aria-current]');
        if (b) b.setAttribute('aria-current', 'false');
      });
      li.classList.add('is-active');
    });
  });

  /* --- 1b. galleria "slideshow" (temi Horizon): le miniature e le frecce
     erano gestite dal JS del tema. Qui si scorre il contenitore delle slide. --- */
  d.querySelectorAll('slideshow-component, [class*="slideshow-component"]').forEach(function (sc) {
    var scroller = sc.querySelector('slideshow-slides, [ref="scroller"]');
    if (!scroller) return;
    var slides = Array.prototype.slice.call(scroller.children);
    var thumbs = Array.prototype.slice.call(
      sc.querySelectorAll('[ref="thumbnails[]"], .slideshow-controls__thumbnail'));
    if (getComputedStyle(scroller).overflowX === 'hidden') scroller.classList.add('dp-scrollable');

    function go(i) {
      var s = slides[i];
      if (!s) return;
      /* scroll immediato: col scroll-behavior:smooth del tema clonato
         l'animazione veniva interrotta dalle immagini in lazy-load */
      dpSetScroll(scroller, s.offsetLeft - slides[0].offsetLeft);
      thumbs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
      slides.forEach(function (x, j) { x.setAttribute('aria-hidden', j === i ? 'false' : 'true'); });
    }
    function current() {
      var best = 0, dist = Infinity;
      slides.forEach(function (s, j) {
        var dd = Math.abs((s.offsetLeft - slides[0].offsetLeft) - scroller.scrollLeft);
        if (dd < dist) { dist = dd; best = j; }
      });
      return best;
    }
    thumbs.forEach(function (t, i) {
      var m = /\/select\/(\d+)/.exec(t.getAttribute('on:click') || '');
      var idx = m ? parseInt(m[1], 10) : i;
      t.addEventListener('click', function (e) { e.preventDefault(); go(idx); });
    });
    var prev = sc.querySelector('.slideshow-control--previous, [ref="previous"]');
    var next = sc.querySelector('.slideshow-control--next, [ref="next"]');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(Math.max(0, current() - 1)); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(Math.min(slides.length - 1, current() + 1)); });
  });

  /* --- 2. galleria a immagine singola (data-sp-*, PageFly, GemPages) --- */
  d.querySelectorAll('[data-sp-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.getAttribute('data-sp-group');
      var main = d.querySelector('[data-sp-main="' + group + '"]');
      if (!main) return;
      var src = btn.getAttribute('data-sp-src'), srcw = btn.getAttribute('data-sp-srcw');
      if (src) main.src = src.indexOf('//') === 0 ? 'https:' + src : src;
      var pic = main.closest('picture');
      if (pic && srcw) {
        var s = pic.querySelector('source');
        if (s) s.srcset = srcw.indexOf('//') === 0 ? 'https:' + srcw : srcw;
      }
      var act = btn.getAttribute('data-sp-active') || '#333';
      d.querySelectorAll('[data-sp-group="' + group + '"]').forEach(function (b) { b.style.borderColor = 'transparent'; });
      btn.style.borderColor = act;
    });
  });

  /* --- 3. slider orizzontali: frecce prev/next --- */
  function dpFindScroller(btn) {
    /* prima si guarda dentro il carosello a cui la freccia appartiene:
       cercando solo "il primo elemento scrollabile" si finiva su un altro slider */
    var box = btn.closest('.splide, slideshow-component, [class*="slider"], [class*="carousel"], [class*="swiper"]');
    if (box) {
      /* prima il contenitore figlio diretto: cercando in profondita' si finiva
         su un carosello annidato con slide di larghezza diversa */
      var direct = box.querySelector(':scope > .splide__track, :scope > .swiper-wrapper, :scope > slideshow-slides, :scope > ul, :scope > .dp-scrollable');
      if (direct && direct.scrollWidth > direct.clientWidth + 8) return direct;
      var t = box.querySelector('.splide__track, slideshow-slides, .dp-scrollable, [class*="track"]');
      if (t && t.scrollWidth > t.clientWidth + 8) return t;
      var inner = box.querySelectorAll('*');
      for (var k = 0; k < inner.length && k < 400; k++) {
        if (inner[k].scrollWidth > inner[k].clientWidth + 8 && inner[k].clientWidth > 80) return inner[k];
      }
    }
    var el = btn.parentElement, hops = 0;
    while (el && hops++ < 7) {
      if (el.scrollWidth > el.clientWidth + 8) return el;
      var cands = el.querySelectorAll('*');
      for (var i = 0; i < cands.length && i < 400; i++) {
        if (cands[i].scrollWidth > cands[i].clientWidth + 8 && cands[i].clientWidth > 80) return cands[i];
      }
      el = el.parentElement;
    }
    return null;
  }

  function dpSlides(scroller) {
    /* le slide sono il primo gruppo di elementi con posizioni orizzontali diverse:
       a volte figli diretti del contenitore, a volte dentro una lista */
    function distinte(arr) { return arr.length > 1 && arr[1].offsetLeft !== arr[0].offsetLeft; }
    /* se dentro c'e' una vera lista di slide si usa quella: i contenitori dei
       caroselli ospitano anche frecce e pallini, che falsano il calcolo */
    var lista = scroller.querySelector(':scope > .splide__list, :scope > .swiper-wrapper, :scope > ul, :scope > ol');
    if (lista && lista.children.length > 1) return Array.prototype.slice.call(lista.children);
    var kids = Array.prototype.slice.call(scroller.children);
    if (distinte(kids)) return kids;
    for (var i = 0; i < kids.length; i++) {
      var sub = Array.prototype.slice.call(kids[i].children);
      if (distinte(sub)) return sub;
    }
    return kids;
  }

  function dpGoTo(scroller, i) {
    var slides = dpSlides(scroller);
    var s = slides[Math.max(0, Math.min(slides.length - 1, i))];
    if (!s) return;
    dpSetScroll(scroller, s.offsetLeft - slides[0].offsetLeft);
  }

  /* scroll immediato: scroll-behavior smooth e scroll-snap mandatory
     annullerebbero lo spostamento fatto via JS */
  function dpSetScroll(scroller, left) {
    var b = scroller.style.scrollBehavior;
    scroller.style.scrollBehavior = 'auto';
    /* lo snap resta disattivato: senza il JS del tema le slide non hanno punti
       di aggancio e il browser riporterebbe subito il carosello a inizio corsa */
    scroller.style.scrollSnapType = 'none';
    /* scrollTo con behavior esplicito ha la precedenza sul CSS, anche quando il
       tema clonato dichiara scroll-behavior:smooth !important */
    if (scroller.scrollTo) scroller.scrollTo({ left: left, behavior: 'auto' });
    else scroller.scrollLeft = left;
    setTimeout(function () { scroller.style.scrollBehavior = b; }, 80);
  }

  function dpCurrent(scroller) {
    var slides = dpSlides(scroller), best = 0, dist = Infinity;
    slides.forEach(function (s, j) {
      var dd = Math.abs((s.offsetLeft - slides[0].offsetLeft) - scroller.scrollLeft);
      if (dd < dist) { dist = dd; best = j; }
    });
    return best;
  }

  function dpStep(btn, dir) {
    var scroller = dpFindScroller(btn);
    if (!scroller) return false;
    var slides = dpSlides(scroller);
    var pitch = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : 0;
    if (pitch > 0) {
      /* passo calcolato dalla distanza fra due slide: niente indici da sbagliare */
      var idx = Math.round(scroller.scrollLeft / pitch) + dir;
      dpSetScroll(scroller, Math.max(0, idx) * pitch);
    } else {
      /* slide senza posizioni distinguibili (slider con transform):
         si scorre comunque di quasi una schermata */
      dpSetScroll(scroller, scroller.scrollLeft + dir * Math.round(scroller.clientWidth * 0.9));
    }
    return true;
  }

  var NEXT_SEL = '.slider-button--next, .pf-slider-next, .swiper-button-next, .splide__arrow--next,' +
                 ' [class*="slideshow-control"][name="next"], button[aria-label*="Next" i], button[aria-label*="destra" i]';
  var PREV_SEL = '.slider-button--prev, .pf-slider-prev, .swiper-button-prev, .splide__arrow--prev,' +
                 ' [class*="slideshow-control"][name="previous"], button[aria-label*="Previous" i], button[aria-label*="sinistra" i]';

  /* le frecce stanno dentro al contenitore scorrevole: il focus del click le
     porterebbe in vista facendo saltare il carosello a fine corsa */
  function dpNoFocusJump(b) {
    b.addEventListener('mousedown', function (e) { e.preventDefault(); });
  }

  d.querySelectorAll(NEXT_SEL).forEach(function (b) {
    if (b.closest('slideshow-component')) return;      /* gestito dalla galleria sopra */
    dpNoFocusJump(b);
    b.addEventListener('click', function (e) {
      if (e.dpHandled) return;                 /* un solo passo per click */
      e.dpHandled = true;
      e.preventDefault();
      e.stopPropagation();
      dpStep(b, 1);
    });
  });
  d.querySelectorAll(PREV_SEL).forEach(function (b) {
    if (b.closest('slideshow-component')) return;
    dpNoFocusJump(b);
    b.addEventListener('click', function (e) {
      if (e.dpHandled) return;
      e.dpHandled = true;
      e.preventDefault();
      e.stopPropagation();
      dpStep(b, -1);
    });
  });

  /* --- 3a-bis. frecce dei caroselli noti: gestore dedicato per istanza.
     Il generico poteva agganciare il contenitore di un altro carosello. --- */
  d.querySelectorAll('.splide, .swiper, .pf-media-slider').forEach(function (box) {
    var track = box.querySelector(':scope > .splide__track') || box;
    var list = track.querySelector(':scope > .splide__list, :scope > .swiper-wrapper') || track;
    if (list.children.length < 2) return;
    var pitch = list.children[1].offsetLeft - list.children[0].offsetLeft;
    if (pitch <= 0) return;

    function passo(dir) {
      var p = list.children[1].offsetLeft - list.children[0].offsetLeft || pitch;
      track.style.setProperty('scroll-snap-type', 'none', 'important');
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = track.scrollLeft + dir * p;
    }
    function lega(sel, dir) {
      box.querySelectorAll(sel).forEach(function (b) {
        /* le frecce erano state salvate disabilitate (carosello alla prima slide) */
        b.removeAttribute('disabled');
        b.disabled = false;
        b.removeAttribute('aria-disabled');
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          passo(dir);
        }, true);
        b.addEventListener('mousedown', function (e) { e.preventDefault(); });
      });
    }
    lega('.splide__arrow--next, .swiper-button-next, .pf-slider-next', 1);
    lega('.splide__arrow--prev, .swiper-button-prev, .pf-slider-prev', -1);

    /* pallini: portano alla slide corrispondente */
    var dots = Array.prototype.slice.call(box.querySelectorAll('.splide__pagination button, .swiper-pagination-bullet'));
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var p = list.children[1].offsetLeft - list.children[0].offsetLeft || pitch;
        track.style.setProperty('scroll-snap-type', 'none', 'important');
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = i * p;
        dots.forEach(function (x, j) { x.classList.toggle('is-active', j === i); });
      }, true);
    });
  });

  /* --- 3b. pallini di paginazione dei caroselli --- */
  d.querySelectorAll('.splide__pagination, [class*="pagination"], [class*="dots"]').forEach(function (nav) {
    var dots = Array.prototype.slice.call(nav.querySelectorAll('button, li'));
    if (dots.length < 2) return;
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) {
        var box = nav.closest('.splide, [class*="slider"], [class*="carousel"], section, div');
        var scroller = box ? box.querySelector('.dp-scrollable, .splide__track, [class*="track"]') : null;
        if (!scroller || scroller.scrollWidth <= scroller.clientWidth + 8) scroller = dpFindScroller(nav);
        if (!scroller) return;
        e.preventDefault();
        dpGoTo(scroller, i);
        dots.forEach(function (x, j) { x.classList.toggle('is-active', j === i); });
      });
    });
  });

  /* --- 4. tab (PageFly / GemPages): mostra il pannello corrispondente --- */
  d.querySelectorAll('[data-tab-trigger], .pf-tab-title, [class*="tab-title"]').forEach(function (t, i) {
    t.addEventListener('click', function () {
      var wrap = t.closest('[class*="tabs"], [data-tabs]');
      if (!wrap) return;
      var triggers = wrap.querySelectorAll('[data-tab-trigger], .pf-tab-title, [class*="tab-title"]');
      var panels = wrap.querySelectorAll('[data-tab-panel], .pf-tab-content, [class*="tab-content"]');
      var idx = Array.prototype.indexOf.call(triggers, t);
      triggers.forEach(function (x) { x.classList.remove('active', 'is-active'); });
      t.classList.add('active');
      panels.forEach(function (p, j) { p.style.display = j === idx ? '' : 'none'; });
    });
  });

  /* --- 0b. countdown: il tema originale lo faceva scorrere via JS, qui restava
     fermo sull'orario in cui la pagina e' stata copiata. Conta fino a mezzanotte,
     come dice il testo della sezione. --- */
  (function () {
    var boxes = [];
    d.querySelectorAll('[data-countdown], [data-hours], [data-minutes], [data-seconds]').forEach(function (el) {
      var box = el.hasAttribute('data-countdown') ? el : el.parentElement;
      while (box && !box.querySelector('[data-seconds], [data-minutes]')) box = box.parentElement;
      if (box && boxes.indexOf(box) === -1) boxes.push(box);
    });
    if (!boxes.length) return;

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function tick() {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      var left = Math.max(0, Math.floor((end - now) / 1000));
      var dd = Math.floor(left / 86400),
          hh = Math.floor(left % 86400 / 3600),
          mm = Math.floor(left % 3600 / 60),
          ss = left % 60;
      boxes.forEach(function (box) {
        var set = function (sel, v) {
          var n = box.querySelector(sel);
          if (n && n.textContent !== pad(v)) n.textContent = pad(v);
        };
        set('[data-days]', dd); set('[data-hours]', hh);
        set('[data-minutes]', mm); set('[data-seconds]', ss);
      });
    }
    tick();
    setInterval(tick, 1000);
  })();

  /* --- 0c. altezze fissate dal JS del tema al momento della copia: su schermi
     stretti il testo e' piu' alto e veniva tagliato. Si tolgono se non basta. --- */
  function dpFixHeights() {
    var SEL = '[style*="height"], .splide__track, [class*="track"], [class*="review"],' +
              ' [class*="testimonial"], [class*="quote"], [class*="slide"], [class*="card"],' +
              ' [class*="carousel"], [class*="jdgm"]';
    d.querySelectorAll(SEL).forEach(function (el) {
      if (el.scrollHeight <= el.clientHeight + 6) return;
      if (el.closest('.dp-modal, .p3d')) return;   /* pagine nostre: gia' responsive */              /* le finestre legali scrollano apposta */
      var cs = getComputedStyle(el);
      if (cs.overflowY === 'visible') return;
      el.style.setProperty('height', 'auto', 'important');
      el.style.setProperty('min-height', '0', 'important');
      el.style.setProperty('max-height', 'none', 'important');
    });
  }
  /* --- 0d. elementi piu' larghi dello schermo (tabelle comparative, contenitori
     con min-width dal desktop): si stringono, e se il contenuto non ci sta
     diventano scorrevoli invece di uscire dalla pagina. --- */
  function dpFixWidths() {
    var vw = d.documentElement.clientWidth;
    d.querySelectorAll('table').forEach(function (t) {
      var r = t.getBoundingClientRect();
      if (r.width <= vw + 1 && r.right <= vw + 1) return;
      if (t.closest('.dp-modal, .p3d')) return;
      /* la tabella viene fatta rientrare, non resa scorrevole: una tabella di
         confronto mezza fuori schermo si legge peggio di una compressa */
      t.classList.add('dp-table-fit');
      var box = t.parentElement;
      if (box) {
        box.style.setProperty('min-width', '0', 'important');
        box.style.setProperty('max-width', '100%', 'important');
        box.style.removeProperty('overflow-x');
        box.classList.remove('dp-scrollable');
      }
    });
    d.querySelectorAll('[class*="container"], [class*="wrapper"], [class*="table"]').forEach(function (el) {
      if (el.closest('.dp-modal, .p3d, [class*="ticker"], [class*="marquee"]')) return;
      var r = el.getBoundingClientRect();
      if (r.width <= vw + 1) return;
      el.style.setProperty('min-width', '0', 'important');
      el.style.setProperty('max-width', '100%', 'important');
      if (el.scrollWidth > el.clientWidth + 4) el.classList.add('dp-scrollable');
    });
  }

  /* --- 0e. snap senza punti di aggancio: lo scorrimento col dito tornava
     indietro di colpo. Se nessuna slide dichiara scroll-snap-align, si toglie. --- */
  function dpFixSnap() {
    d.querySelectorAll('.dp-scrollable, .splide__track, slideshow-slides, [class*="track"], [class*="slider"], [class*="swiper"], [class*="carousel"]')
      .forEach(function (el) {
        if (el.closest('.p3d')) return;
        if (el.scrollWidth <= el.clientWidth + 8) return;
        var cs = getComputedStyle(el);
        if (cs.scrollSnapType === 'none' || !cs.scrollSnapType) return;
        var kids = dpSlides(el);
        var ok = kids.length > 1 && kids.every(function (k) {
          var a = getComputedStyle(k).scrollSnapAlign;
          return a && a !== 'none';
        });
        if (!ok) el.style.setProperty('scroll-snap-type', 'none', 'important');
      });
  }

  /* --- 0f. quante slide stanno in vista lo decideva il JS del tema: sul clone
     resta il conteggio del desktop e su telefono si vedono 3 card minuscole
     con le didascalie tagliate. Sotto i 560px le slide troppo strette vengono
     allargate. --- */
  function dpFixSlideWidth() {
    if (window.innerWidth >= 560) return;
    d.querySelectorAll('.splide__list, .swiper-wrapper').forEach(function (list) {
      if (list.closest('.p3d')) return;
      var track = list.parentElement;
      if (!track || list.children.length < 2) return;
      var w = list.children[0].getBoundingClientRect().width;
      if (!w || w >= 150 || track.clientWidth < 200) return;
      var target = Math.round(track.clientWidth * 0.62);
      Array.prototype.forEach.call(list.children, function (k) {
        k.style.setProperty('width', target + 'px', 'important');
        k.style.setProperty('min-width', target + 'px', 'important');
        k.style.setProperty('max-width', target + 'px', 'important');
      });
    });
  }

  dpFixHeights();
  dpFixWidths();
  dpFixSnap();
  dpFixSlideWidth();
  setTimeout(function () { dpFixHeights(); dpFixWidths(); dpFixSnap(); dpFixSlideWidth(); }, 1200);
  var dpRT;
  window.addEventListener('resize', function () {
    clearTimeout(dpRT);
    dpRT = setTimeout(function () { dpFixHeights(); dpFixWidths(); dpFixSnap(); dpFixSlideWidth(); }, 200);
  });

  /* --- 4a. caroselli senza il loro JS: contenuto tagliato e irraggiungibile.
     Li rendiamo scorrevoli col dito, saltando i marquee (che si animano da soli). --- */
  function animated(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    return cs.animationName !== 'none' || cs.transitionProperty.indexOf('transform') > -1 && cs.transform !== 'none';
  }
  d.querySelectorAll('div:not(.jdgm-carousel__item-container), ul, ol, section').forEach(function (el) {
    if (el.closest('.p3d')) return;
    var cs = getComputedStyle(el);
    if (cs.overflowX !== 'hidden' && cs.overflowX !== 'clip') return;
    if (el.clientWidth < 120 || el.scrollWidth <= el.clientWidth + 8) return;
    if (/ticker|marquee/i.test(el.className || '')) return;
    if (animated(el) || animated(el.firstElementChild)) return;
    el.classList.add('dp-scrollable');
    el.style.setProperty('scroll-snap-type', 'none', 'important');
  });

  /* --- 4b. FAQ del tema "slow pencil": apri/chiudi con la griglia 0fr/1fr --- */
  d.querySelectorAll('[data-sp-faq-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = d.getElementById(btn.getAttribute('aria-controls'));
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (panel) panel.style.gridTemplateRows = open ? '0fr' : '1fr';
      var ico = btn.querySelector('[data-sp-faq-icon]');
      if (ico) ico.style.transform = open ? 'none' : 'rotate(45deg)';
    });
  });

  /* --- 4c. selettori di quantita' --- */
  d.querySelectorAll('button[name="minus"], button[name="plus"], .quantity-minus, .quantity-plus').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var box = (b.parentElement && b.parentElement.closest('quantity-selector-component, quantity-input, .quantity-selector, .quantity, .quantity-input, [class*="quantity"]')) || b.parentElement;
      var inp = box && box.querySelector('input[type="number"], input[name="quantity"]');
      if (!inp) return;
      var min = parseInt(inp.min || '1', 10) || 1;
      var v = parseInt(inp.value || min, 10) || min;
      var plus = b.name === 'plus' || /plus/.test(b.className);
      inp.value = Math.max(min, v + (plus ? 1 : -1));
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* --- 4d. controlli di app che qui non hanno backend: meglio non mostrarli --- */
  d.querySelectorAll('.forge-reviews__add-btn, .forge-reviews__pagination, .jdgm-write-rev-link, .jdgm-paginate, .spr-summary-actions').forEach(function (el) {
    el.style.display = 'none';
  });

  /* --- 5. accordion custom senza <details> --- */
  d.querySelectorAll('[data-accordion-trigger], .pf-accordion-title').forEach(function (t) {
    t.addEventListener('click', function () {
      var body = t.nextElementSibling;
      if (body) body.hidden = !body.hidden;
    });
  });
})();

/* ---------------------------------------------------------------------------
   bio-energetic-reset: la landing originale e' una SPA React. Fuori da React
   restano fermi countdown, FAQ, Field Check e scelta del pacchetto: qui si
   riaccendono. Tutto il blocco gira solo su quella pagina.
--------------------------------------------------------------------------- */
(function () {
  var d = document;
  if (!d.querySelector('[data-dp-bio]')) return;

  /* --- countdown del regalo: 6 ore per visitatore --- */
  var KEY = 'dp_bio_gift_ends', SPAN = 6 * 3600 * 1000, ends;
  try { ends = parseInt(localStorage.getItem(KEY), 10); } catch (e) { ends = 0; }
  if (!ends || isNaN(ends) || ends < Date.now() || ends > Date.now() + SPAN) {
    ends = Date.now() + SPAN;
    try { localStorage.setItem(KEY, String(ends)); } catch (e) {}
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  var cells = { h: [], m: [], s: [] };
  d.querySelectorAll('[data-dp-clock]').forEach(function (el) {
    var k = el.getAttribute('data-dp-clock');
    if (cells[k]) cells[k].push(el);
  });
  var fulls = d.querySelectorAll('[data-dp-clock="full"]');
  function tickClock() {
    var left = ends - Date.now();
    if (left <= 0) { ends = Date.now() + SPAN; try { localStorage.setItem(KEY, String(ends)); } catch (e) {} left = SPAN; }
    var t = Math.floor(left / 1000), h = Math.floor(t / 3600), m = Math.floor(t % 3600 / 60), s = t % 60;
    cells.h.forEach(function (el) { el.textContent = pad(h); });
    cells.m.forEach(function (el) { el.textContent = pad(m); });
    cells.s.forEach(function (el) { el.textContent = pad(s); });
    fulls.forEach(function (el) {
      // il testo originale decideva il formato: "5:53:56" oppure "5h 54m"
      el.textContent = /h/.test(el.dataset.dpFmt || el.textContent)
        ? h + 'h ' + pad(m) + 'm'
        : h + ':' + pad(m) + ':' + pad(s);
    });
  }
  fulls.forEach(function (el) { el.dataset.dpFmt = el.textContent; });
  tickClock();
  setInterval(tickClock, 1000);

  /* --- FAQ: la risposta e' il div subito dopo il bottone --- */
  d.querySelectorAll('[data-dp-faq]').forEach(function (b) {
    b.addEventListener('click', function () {
      var a = b.nextElementSibling, open = b.getAttribute('aria-expanded') === 'true';
      b.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (a && a.classList.contains('dp-faq-a')) a.hidden = open;
      var plus = b.querySelector('span[style*="rotate"]');
      if (plus) plus.style.transform = open ? 'rotate(0deg)' : 'rotate(45deg)';
    });
  });

  /* --- Field Check: stesse classi e stesso riepilogo del sito originale --- */
  var CHK_ON = 'w-full text-left p-4 md:p-5 rounded-sm border transition-all duration-300 border-[#2A7F7F] bg-[#2A7F7F]/5 shadow-sm';
  var CHK_OFF = 'w-full text-left p-4 md:p-5 rounded-sm border transition-all duration-300 border-[#E8E4DF] bg-white hover:border-[#2A7F7F]/30';
  var BOX_ON = 'w-5 h-5 rounded-sm border-2 flex-shrink-0 mt-0.5 flex items-center justify-center transition-all duration-300 border-[#2A7F7F] bg-[#2A7F7F]';
  var BOX_OFF = 'w-5 h-5 rounded-sm border-2 flex-shrink-0 mt-0.5 flex items-center justify-center transition-all duration-300 border-[#C8C4BF]';
  var TICK = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M3 6L5 8L9 4" stroke="#FAF8F5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var MSG = {
    1: 'You recognized one. There may be more.',
    2: 'Two signs. Your field is carrying a significant load.',
    3: 'Three out of six. Your nervous system is heavily congested.',
    4: 'Four signs. You are carrying an enormous amount of accumulated stress.',
    5: 'Five signs. Your system is deeply saturated.',
    6: 'All six. Your system is completely saturated. This protocol was designed specifically for you.'
  };
  var checks = d.querySelectorAll('[data-dp-check]');
  var sumBox = d.querySelector('[data-dp-checksum]');
  function refresh() {
    var n = 0;
    checks.forEach(function (c) { if (c.getAttribute('data-dp-on') === '1') n++; });
    if (!sumBox) return;
    sumBox.hidden = n === 0;
    if (n > 0) sumBox.firstChild.textContent = n + ' of 6 recognized \u2014 ' + MSG[n];
  }
  checks.forEach(function (c) {
    var box = c.querySelector('div[class*="w-5"]');
    c.addEventListener('click', function () {
      var on = c.getAttribute('data-dp-on') === '1';
      c.setAttribute('data-dp-on', on ? '0' : '1');
      c.className = on ? CHK_OFF : CHK_ON;
      if (box) { box.className = on ? BOX_OFF : BOX_ON; box.innerHTML = on ? '' : TICK; }
      refresh();
    });
  });

  /* --- scelta del pacchetto: aggiorna grafica, prezzi e form d'acquisto --- */
  var tiers = d.querySelectorAll('[data-dp-tier]');
  if (tiers.length) {
    // classi e spunta della voce selezionata, prese dal DOM originale
    var on = d.querySelector('[data-dp-tier][aria-checked="true"]');
    var off = d.querySelector('[data-dp-tier][aria-checked="false"]');
    var CLS_ON = on ? on.className : '', CLS_OFF = off ? off.className : '';
    var dotOn = on ? on.querySelector('span[aria-hidden]') : null;
    var dotOff = off ? off.querySelector('span[aria-hidden]') : null;
    var DOT_ON = dotOn ? dotOn.className : '', DOT_OFF = dotOff ? dotOff.className : '';
    var CHECK = dotOn ? dotOn.innerHTML : '';

    function priceOf(t) {
      var el = t.querySelector('[data-dp-tierprice]');
      return el ? el.textContent.trim() : '';
    }
    function pick(kind) {
      var price = '';
      tiers.forEach(function (t) {
        var mine = t.getAttribute('data-dp-tier') === kind;
        if (mine) price = priceOf(t);
        t.setAttribute('aria-checked', mine ? 'true' : 'false');
        t.className = mine ? CLS_ON : CLS_OFF;
        var dot = t.querySelector('span[aria-hidden]');
        if (dot) {
          dot.className = mine ? DOT_ON : DOT_OFF;
          dot.innerHTML = mine ? CHECK : '';
        }
      });
      if (price) {
        d.querySelectorAll('[data-dp-bigprice]').forEach(function (el) { el.textContent = price; });
        d.querySelectorAll('[data-dp-ctalabel]').forEach(function (el) {
          el.innerHTML = el.innerHTML.replace(/\$[\d.,]+/, price);
        });
      }
      d.querySelectorAll('[form="dp-atc"], [form="dp-atc-kit"]').forEach(function (b) {
        b.setAttribute('form', kind === 'kit' ? 'dp-atc-kit' : 'dp-atc');
      });
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function () { pick(t.getAttribute('data-dp-tier')); });
    });
  }
})();

/* barra sticky della landing bio: compare dopo l'hero, sparisce sull'offerta */
(function () {
  var bar = document.querySelector('[data-dp-sticky]');
  if (!bar) return;
  var hero = document.querySelector('[data-dp-bio]');
  function onScroll() {
    var past = window.pageYOffset > (window.innerHeight * 0.9);
    var end = document.body.scrollHeight - window.innerHeight - window.pageYOffset < 900;
    bar.style.transform = (past && !end) ? 'translateY(0)' : 'translateY(110%)';
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* VSL della landing bio: l'overlay con il tasto play copre il video e nel sito
   originale lo faceva partire React. Qui il click toglie il muto, riparte da
   zero e scopre i comandi nativi. */
(function () {
  document.querySelectorAll('video[data-lp-vsl]').forEach(function (v) {
    var overlay = v.nextElementSibling;
    if (!overlay || overlay.tagName !== 'DIV') return;
    function start() {
      overlay.style.opacity = '0';
      overlay.style.pointerEvents = 'none';
      v.muted = false;
      v.volume = 1;
      v.controls = true;
      try { v.currentTime = 0; } catch (e) {}
      var p = v.play();
      if (p && p.catch) p.catch(function () { v.muted = true; v.play(); });
    }
    overlay.style.cursor = 'pointer';
    overlay.addEventListener('click', start);
    // se parte dai comandi nativi, l'overlay deve comunque sparire
    v.addEventListener('play', function () {
      if (!v.muted) { overlay.style.opacity = '0'; overlay.style.pointerEvents = 'none'; }
    });
  });
})();
